// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card {
  box-sizing: border-box;
  width: 100%;
  min-height: 269px;
  padding: 9px;
  background: #ffffff;
  border: 2px solid #a78c83;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-card--clickable {
  cursor: pointer;
}

.product-card--unavailable {
  opacity: 0.65;
  filter: grayscale(0.4);
}

.product-card--unavailable .product-card__btn {
  background: #e0d8d3;
  color: #7a6d68;
  cursor: not-allowed;
}

.product-card__unavailable-tag {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 4px 10px;
  background: #df484f;
  color: #ffffff;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 8px;
  pointer-events: none;
}

.product-card__image-wrap {
  position: relative;
  width: 100%;
  max-width: 161px;
  height: 121px;
  flex-shrink: 0;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #a78c83;
  box-sizing: border-box;
}

.product-card__image-wrap--dimmed .product-card__image {
  opacity: 0.6;
}

.product-card__image {
  width: 100%;
  height: 100%;
  background-color: #e8e4df;
  background-size: cover;
  background-position: center;
  transition: opacity 0.2s;
}

.product-card__combo-badge {
  position: absolute;
  left: 6px;
  bottom: 6px;
  z-index: 1;
  padding: 4px 10px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: #2d6a4f;
  border-radius: 10px;
}

.product-card__count {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 64px;
  line-height: 75px;
  color: #4e3f3a;
  margin: 0;
  pointer-events: none;
}

.product-card__price {
  margin: 8px 0 4px 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #4e3f3a;
}

.product-card__bonus {
  margin: 0 0 4px 0;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 14px;
  color: #8a6d3b;
  text-align: center;
  max-width: 100%;
}

.product-card__name {
  margin: 0 0 4px 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #4e3f3a;
  text-align: center;
  max-width: 100%;
}

.product-card__grams {
  margin: 0 0 6px 0;
  align-self: flex-start;
  margin-left: 1px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #4e3f3a;
  opacity: 0.5;
}

/* Кнопка «В корзину» */
.product-card__btn {
  box-sizing: border-box;
  width: 100%;
  height: 33px;
  background: #ff9702;
  border: 2px solid #a78c83;
  border-radius: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #4e3f3a;
  cursor: pointer;
  margin-top: auto;
}

.product-card__btn:hover {
  opacity: 0.95;
}

/* Блок с − и + в корзине */
.product-card__controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 33px;
  margin-top: auto;
  background: #ffcf8b;
  border-radius: 18px;
  padding: 0;
  box-sizing: border-box;
}

.product-card__circle {
  box-sizing: border-box;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: #ff9702;
  border: 2px solid #f5f1e9;
  font-size: 18px;
  line-height: 1;
  color: #4e3f3a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.product-card__circle:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .product-card {
    min-height: 244px;
    border-radius: 24px;
    padding: 8px;
  }

  .product-card__image-wrap {
    max-width: none;
    height: 112px;
    border-radius: 16px;
  }

  .product-card__price {
    font-size: 20px;
    line-height: 1.2;
  }

  .product-card__btn,
  .product-card__controls {
    height: 36px;
  }
}

@media (max-width: 430px) {
  .product-card {
    min-height: 220px;
    border-radius: 18px;
    border-width: 1px;
    padding: 7px;
  }

  .product-card__image-wrap {
    height: 92px;
    border-radius: 12px;
  }

  .product-card__price {
    margin: 6px 0 4px 0;
    font-size: 17px;
  }

  .product-card__bonus,
  .product-card__name,
  .product-card__grams {
    font-size: 12px;
    line-height: 1.25;
  }

  .product-card__btn,
  .product-card__controls {
    height: 32px;
  }

  .product-card__btn {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductCard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".product-card {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 269px;\n  padding: 9px;\n  background: #ffffff;\n  border: 2px solid #a78c83;\n  border-radius: 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.product-card--clickable {\n  cursor: pointer;\n}\n\n.product-card--unavailable {\n  opacity: 0.65;\n  filter: grayscale(0.4);\n}\n\n.product-card--unavailable .product-card__btn {\n  background: #e0d8d3;\n  color: #7a6d68;\n  cursor: not-allowed;\n}\n\n.product-card__unavailable-tag {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 4px 10px;\n  background: #df484f;\n  color: #ffffff;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 14px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.product-card__image-wrap {\n  position: relative;\n  width: 100%;\n  max-width: 161px;\n  height: 121px;\n  flex-shrink: 0;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #a78c83;\n  box-sizing: border-box;\n}\n\n.product-card__image-wrap--dimmed .product-card__image {\n  opacity: 0.6;\n}\n\n.product-card__image {\n  width: 100%;\n  height: 100%;\n  background-color: #e8e4df;\n  background-size: cover;\n  background-position: center;\n  transition: opacity 0.2s;\n}\n\n.product-card__combo-badge {\n  position: absolute;\n  left: 6px;\n  bottom: 6px;\n  z-index: 1;\n  padding: 4px 10px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  background: #2d6a4f;\n  border-radius: 10px;\n}\n\n.product-card__count {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 64px;\n  line-height: 75px;\n  color: #4e3f3a;\n  margin: 0;\n  pointer-events: none;\n}\n\n.product-card__price {\n  margin: 8px 0 4px 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  color: #4e3f3a;\n}\n\n.product-card__bonus {\n  margin: 0 0 4px 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  line-height: 14px;\n  color: #8a6d3b;\n  text-align: center;\n  max-width: 100%;\n}\n\n.product-card__name {\n  margin: 0 0 4px 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 15px;\n  color: #4e3f3a;\n  text-align: center;\n  max-width: 100%;\n}\n\n.product-card__grams {\n  margin: 0 0 6px 0;\n  align-self: flex-start;\n  margin-left: 1px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 15px;\n  color: #4e3f3a;\n  opacity: 0.5;\n}\n\n/* Кнопка «В корзину» */\n.product-card__btn {\n  box-sizing: border-box;\n  width: 100%;\n  height: 33px;\n  background: #ff9702;\n  border: 2px solid #a78c83;\n  border-radius: 18px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #4e3f3a;\n  cursor: pointer;\n  margin-top: auto;\n}\n\n.product-card__btn:hover {\n  opacity: 0.95;\n}\n\n/* Блок с − и + в корзине */\n.product-card__controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 33px;\n  margin-top: auto;\n  background: #ffcf8b;\n  border-radius: 18px;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.product-card__circle {\n  box-sizing: border-box;\n  width: 33px;\n  height: 33px;\n  border-radius: 50%;\n  background: #ff9702;\n  border: 2px solid #f5f1e9;\n  font-size: 18px;\n  line-height: 1;\n  color: #4e3f3a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.product-card__circle:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .product-card {\n    min-height: 244px;\n    border-radius: 24px;\n    padding: 8px;\n  }\n\n  .product-card__image-wrap {\n    max-width: none;\n    height: 112px;\n    border-radius: 16px;\n  }\n\n  .product-card__price {\n    font-size: 20px;\n    line-height: 1.2;\n  }\n\n  .product-card__btn,\n  .product-card__controls {\n    height: 36px;\n  }\n}\n\n@media (max-width: 430px) {\n  .product-card {\n    min-height: 220px;\n    border-radius: 18px;\n    border-width: 1px;\n    padding: 7px;\n  }\n\n  .product-card__image-wrap {\n    height: 92px;\n    border-radius: 12px;\n  }\n\n  .product-card__price {\n    margin: 6px 0 4px 0;\n    font-size: 17px;\n  }\n\n  .product-card__bonus,\n  .product-card__name,\n  .product-card__grams {\n    font-size: 12px;\n    line-height: 1.25;\n  }\n\n  .product-card__btn,\n  .product-card__controls {\n    height: 32px;\n  }\n\n  .product-card__btn {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
